<template>
  <div class="fillcontain">
    <div class="table_container">
      <el-row>
        <el-button type="primary" @click="handleEdit(0, '','add')">新增排队分组</el-button>
        <el-button type="primary" @click="queueHandleEdit(0, '','add')">新增排队</el-button>
      </el-row>
      <br/>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading">
        <el-table-column
          label="组名"
          prop="name">
        </el-table-column>
        <el-table-column
          label="人数"
          :formatter="peopleNumFormat"
        >
        </el-table-column>
        <el-table-column
          label="状态"
          :formatter="statusFormat">
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row,'edit')">
              编辑
            </el-button>
            <el-button
              size="mini"
              @click="goOtherPage('/store/queue_up',scope.row)">
              排队详情
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDeleteAlert( scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
        <el-form :model="queue_group">
          <el-form-item label="分组名" label-width="100px">
            <el-input v-model="queue_group.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="队列前缀" label-width="100px">
            <el-input v-model="queue_group.prefix" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="最少人数" label-width="100px">
            <el-input-number v-model="queue_group.minPeopleCount" :min="1" :max="1000" auto-complete="off"></el-input-number>
          </el-form-item>
          <el-form-item label="最多人数" label-width="100px">
            <el-input-number v-model="queue_group.maxPeopleCount" :min="1" :max="1000" auto-complete="off"></el-input-number>
          </el-form-item>

          <el-form-item label="状态" label-width="80px">

            <el-switch
              v-model="queue_group.status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="上架"
              inactive-text="下架"
              :active-value=2
              :inactive-value=1>
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog v-loading="queueDialog.loading" :title="queueDialog.title" :visible.sync="queueDialog.dialogFormVisible" :close-on-click-modal="dialog.close">
        <el-form :model="queue" >
          <el-form-item label="人数" label-width="100px">
            <el-input-number v-model="queue.peopleNum" auto-complete="off" :min=1 :max=10000></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="queueDialog.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="queueHandleSave">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                queue_group:{
                    id:0,
                    name:"",
                  status:1,
                  prefix:"",
                  minPeopleCount:1,
                  maxPeopleCount:1
                },
                dialog:{
                    dialogFormVisible:false,
                    title:"新增菜品分组",
                    close:false,
                },
                queueDialog:{
                  dialogFormVisible:false,
                  loading:false,
                  title:"新增菜品分组",
                  close:false,

                },
                queue:{
                  peopleNum:1,
                },
                tableData: [],
            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
                this.loading = true;
                var that = this;
                that.$api.get('/store/queue_up/group', {}, response => {
                    if (response.status >= 200 && response.status < 300) {
                        var res = response.data;
                        if (res.code == 0) {
                            that.tableData = res.data.queueUpGroups;
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }
                    this.loading = false;
                });
            },

          statusFormat(row,column){
            return row.status == 2?"上架":"下架";
          },
          peopleNumFormat(row,column){
            return row.minPeopleCount+"-"+row.maxPeopleCount;
          },

            handleEdit(index, row,action) {
                this.picFiles = new Array();
                if(action == "edit"){
                    this.dialog.title = "修改排队分组";
                    this.queue_group.id = row.id;
                    this.queue_group.name = row.name;
                    this.queue_group.status = row.status;
                    this.queue_group.minPeopleCount = row.minPeopleCount;
                    this.queue_group.maxPeopleCount = row.maxPeopleCount;
                    this.queue_group.prefix = row.prefix;

                    this.dialog.dialogFormVisible = true;
                }else if(action == "add"){
                    this.dialog.title = "新增排队分组";
                    this.queue_group.id = 0;
                    this.queue_group.name = "";
                    this.queue_group.status = 1;
                    this.queue_group.minPeopleCount = 1;
                    this.queue_group.maxPeopleCount = 1;
                    this.queue_group.prefix = "";
                    this.dialog.dialogFormVisible = true;
                }
            },

            handleSave() {
                this.loading = true;
                var that = this;
                that.$api.post('/store/queue_up/group', that.queue_group, response => {
                    if (response.status >= 200 && response.status < 300) {
                        console.log(response.data);
                        var res = response.data;
                        if (res.code == 0) {
                            this.$message({
                                message: that.dialog.title+'成功',
                                type: 'success'
                            });
                            this.dialog.dialogFormVisible = false;
                            this.initData();
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                    }

                });

                this.loading = false;
            },
            handleDeleteAlert(row) {
                this.$confirm('此操作将删除该排队分组, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleDelete(row);
                }).catch(() => {

                });
            },
            handleDelete(row) {
                this.loading = true;
                var that = this;
                that.$api.delete('/store/queue_up/group/'+row.id, null, response => {
                    if (response.status >= 200 && response.status < 300) {
                        console.log(response.data);
                        var res = response.data;
                        if (res.code == 0) {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.initData();
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                            this.loading = false;
                        }
                    } else {
                        this.$message({
                            message: "服务器维护中",
                            type: 'error'
                        });
                        this.loading = false;
                    }

                });
            },
            goOtherPage(path,row){
              this.$router.push({path:path,query: {group_id: row.id,minPeopleCount:row.minPeopleCount,maxPeopleCount:row.maxPeopleCount}});
            },

            queueHandleEdit(index, row,action) {
              if(action == "edit"){
                this.queueDialog.title = "修改排队分组";
                this.queue.peopleNum = row.peopleNum;
                this.queueDialog.dialogFormVisible = true;
              }else if(action == "add"){
                this.queueDialog.title = "新增排队分组";
                this.queue.peopleNum = 1;
                this.queueDialog.dialogFormVisible = true;
              }
            },

            queueHandleSave() {
              this.queueDialog.loading = true;
              var that = this;
              that.$api.post('/store/queue_up', that.queue, response => {
                if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: that.dialog.title+'成功',
                      type: 'success'
                    });
                    this.$alert('排除编号为：'+res.data.queueUp.prefix + res.data.queueUp.number, '创建成功', {
                      confirmButtonText: '确定',
                      callback: action => {
                        this.$message({
                          type: 'info',
                          message: `action: ${ action }`
                        });
                      }
                    });
                    this.queueDialog.dialogFormVisible = false;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }

              });

              this.queueDialog.loading = false;
            },
        },
    }
</script>

<style lang="less">
  @import '../../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .table_container{
    padding: 20px;
    text-align: left;
  }
  .Pagination{
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/store/TableQueueUpGroups.vue